import { render } from "./ExternalLinkIcon.vue?vue&type=template&id=24af2ed7"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ExternalLinkIcon.vue"]])

export default __exports__